
      (function() {
        const s = document.createElement('script');
        s.src = 'https://www.google.com/recaptcha/api.js?render=6LdfF9oqAAAAAHWK_pT_2FpldABpIDd_GorPaOQM';
        s.type = 'text/javascript';
        s.async = true;
        s.defer = true;
        document.body.appendChild(s);
      })();
    